export default {"src":"/_next/static/media/x-icon.750ec608.svg","height":7,"width":6,"blurWidth":0,"blurHeight":0};